

var addJquery = (function(){
	var i = 0;
	return function(callBack, type){
		if(i > 1) {
			return;
		}
		var script = document.createElement("script")
		script.type = "text/javascript";
		script.src = "../../static/jquery/jquery-1.11.2.min.js";
		// 判断是PC还是M，加载不同路径下的jquery，规定PC-->1;M-->0
		// if(type == 1) {
		// 	script.src = '//j1.58cdn.com.cn/crop/biz/pc/entrance/jquery-1.11.2.min.js';
		// } else {
		// 	script.src = '//j1.58cdn.com.cn/crop/biz/m/entrance/jquery-1.11.2.min.js';
		// }
		document.getElementsByTagName("head")[0].appendChild(script);
		//Firefox, Opera, Chrome, Safari 3+
		//script.onreadystatechange 兼容IE8
		script.onload = script.onreadystatechange = function(){

			if(!this.readyState || this.readyState == "loaded" || this.readyState == "complete") {
			    // 初始化发布页、详情页、发布成功页/初始化布点
			    $(function(){
			    	callBack.init();
			    })
			}
		};
		script.onerror = function(){
		    i++;
		    addJquery(callBack);
		};
	}

})();


export default addJquery